/**
 * EL TEXTO DE UN CORREO: su asunto y su cuerpo, tal cual (08-10).
 *
 * Lo pintan igual la Documentación (la plantilla de cada correo y de cada aviso, con sus
 * variables entre llaves) y el simulador de semanas (el correo ya redactado para un cliente).
 * Lo que cada pantalla pone alrededor es suyo: allí el estado de borrador y las variables,
 * aquí el desplegable y el envío de prueba.
 */
import React from 'react';

// `anywhere` y no `break-words`: un enlace es una palabra larga y, dentro de una rejilla,
// `break-words` no deja encoger la columna: ensanchaba la tarjeta entera en el móvil (medido
// a 390 px en el simulador: 487).
const AsuntoYCuerpo = ({ asunto, cuerpo }) => (
    <div className="space-y-2 min-w-0" style={{ overflowWrap: 'anywhere' }} data-testid="asunto-y-cuerpo">
        <p className="text-sm text-white/60">Asunto: <span className="text-white">{asunto}</span></p>
        <pre className="text-sm text-white/80 whitespace-pre-wrap font-sans border-l-2 border-[#FF671F]/50 pl-3">{cuerpo}</pre>
    </div>
);

export default AsuntoYCuerpo;
